import { useState } from 'react'
import { Button } from 'components/ui/button'
import { Input } from 'components/ui/input'
import { Loader } from 'lucide-react'
import { save } from 'store/customBanners/customBannersSlice'
import { useAppDispatch, useAppSelector } from 'store/store'

const CustomBannerForm = () => {
  const [image, setImage] = useState('')
  const [destination, setDestination] = useState('')
  const dispatch = useAppDispatch()
  const { loading } = useAppSelector((state) => state.customBanners)

  const isValid = () => {
    return image !== '' && destination !== ''
  }

  const handleSave = (event: React.FormEvent): void => {
    event.preventDefault()
    dispatch(save({ image, destination }))
  }

  interface FileInputEvent extends React.ChangeEvent<HTMLInputElement> {
    target: HTMLInputElement & { files: FileList }
  }

  const handleFile = (event: FileInputEvent): void => {
    event.preventDefault()

    const file = event.target.files[0]
    const reader = new FileReader()

    reader.onloadend = () => setImage(reader.result as string)
    reader.readAsDataURL(file)
  }

  const renderContent = () => (
    <form onSubmit={handleSave} className='flex max-w-xl flex-col gap-5'>
      <label>Immagine</label>
      <Input type='file' onChange={handleFile} />
      <label>Destinazione</label>
      <Input
        type='text'
        value={destination}
        onChange={(event) => setDestination(event.target.value)}
      />
      <Button disabled={!isValid()} onClick={handleSave} type='submit'>
        Salva
      </Button>
    </form>
  )

  const content = loading ? (
    <Loader className='h-5 w-5 animate-spin' />
  ) : (
    renderContent()
  )

  return <div>{content}</div>
}

export default CustomBannerForm
